<template>
  <icon-button
    v-if="showApplyButton"
    :disabled="disabledButton"
    :class="applyBtnClasses"
    class="apply-button paragraph-m"
    @click="handleApplyBtnClick()">
    <svg-icon
      v-if="!loading"
      slot="icon"
      :name="!isCandidateUser || !jobApplied ? 'edit' : 'check-icon'"
      class="icon-check"
      width="16"
      height="16">
    </svg-icon>
    <div slot="text">{{ buttonText }}</div>
  </icon-button>
</template>

<script>

import 'top20common/distribution/icons/check-icon';
import 'top20common/distribution/icons/edit';

import {mapGetters} from 'vuex';

import IconButton from '@/common/IconButton';

export default {
  props: {
    smallButton: {
      type: Boolean,
      default: true
    },
    jobApplied: Boolean
  },
  computed: {
    ...mapGetters([
      'jobDetailsState',
      'applicationsLoadingState',
      'userScopesState',
      'createApplicationLoadingState',
      'isCandidateUser',
      'canInterractWithJob',
      'isPublishedJob'
    ]),
    loading() {
      return this.applicationsLoadingState || this.createApplicationLoadingState;
    },
    disabledButton() {
      return this.jobApplied || !this.canInterractWithJob || !this.isPublishedJob;
    },
    applyBtnClasses() {
      return {
        small: this.$mq.phone && this.smallButton,
        'is-loading': this.loading,
        'is-secondary': !this.loading && (!this.isCandidateUser || !this.jobApplied),
        'is-mid-gray': this.loading || this.disabledButton
      };
    },
    buttonText() {
      return this.isCandidateUser && this.jobApplied ? this.$gettext('Applied') : this.$gettext('Apply');
    },
    showApplyButton() {
      return (this.isPublishedJob && this.canInterractWithJob) || this.jobApplied;
    }
  },
  methods: {
    handleApplyBtnClick() {
      this.$mam.trackApplyToJobClicked();
      this.$emit('click');
    }
  },
  components: {IconButton}
};
</script>

<style lang="scss" scoped>
.icon-check /deep/ .stroke {
  stroke: var(--white);
}
.icon-check /deep/ .fill {
  fill: var(--mid-gray);
}
</style>
